export enum CalendarViewType {
  DAY = 'day',
  WEEK = 'week',
}
